<div class="feedback-modal">
  <div class="feedback-modal__header">
    <div class="feedback-modal__icon">
      <ion-icon name="chatbubbles-outline"></ion-icon>
    </div>
    <h2 class="feedback-modal__title">{{ 'FEEDBACK.TITLE' | translate }}</h2>
  </div>

  <p class="feedback-modal__message">{{ messageKey | translate }}</p>

  <div class="feedback-modal__rating">
    <div class="feedback-modal__stars" (mouseleave)="onStarsLeave()">
      <button *ngFor="let star of stars" 
              class="feedback-modal__star"
              [class.filled]="isStarFilled(star)"
              (mouseenter)="onStarHover(star)"
              (click)="onStarClick(star)"
              type="button">
        <ion-icon [name]="isStarFilled(star) ? 'star' : 'star-outline'"></ion-icon>
      </button>
    </div>
    <div class="feedback-modal__time" [class.visible]="selectedStars > 0 || hoveredStars > 0">
      {{ getTimeSavedLabel() }}
    </div>
  </div>

  <p class="feedback-modal__legend">{{ 'FEEDBACK.LEGEND' | translate }}</p>

  <div class="feedback-modal__comment">
    <textarea
      class="feedback-modal__textarea"
      [(ngModel)]="comment"
      [placeholder]="'FEEDBACK.COMMENT_PLACEHOLDER' | translate"
      rows="3"
      maxlength="500">
    </textarea>
  </div>

  <div class="feedback-modal__actions">
    <button class="feedback-modal__btn feedback-modal__btn--primary" 
            [disabled]="selectedStars === 0"
            (click)="onSubmit()" type="button">
      {{ 'FEEDBACK.SUBMIT' | translate }}
    </button>
  </div>
</div>
